export * from './modal-disciplina'
export * from './modal-disciplina-tcc'
export * from './tipos'
export * from './schema'
export * from './modal-modulo'
export * from './modal-alterar-titulo-tcc'
